export const CONSENT_COOKIE_NAME = 'is_accepted_cookie';
